import * as React from "react";
import { Typography, Link, Stack, Grid, Container, Skeleton, useTheme } from "@mui/material";
import Cover from "../../../Misc/Cover";
import { Link as RouterLink } from "react-router";

import { routePaths } from "../../../../Router/router";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { TitleHeroStyled } from "../title-hero";
import { useTranslation } from "react-i18next";

const TitleHeroSkeleton: React.FC<{}> = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <TitleHeroStyled.Hero>
      <TitleHeroStyled.Background>
        {theme.palette.mode === "dark" && <Cover img={{ src: "/static/images/title-cover-fallback.png" }} />}
      </TitleHeroStyled.Background>
      <Container sx={{ pt: 12, pb: 3 }}>
        <Grid container>
          <Grid item md={6} display="flex" flexDirection="column" justifyContent="space-between">
            <Link
              component={RouterLink}
              to={routePaths.home.path}
              underline="hover"
              variant="button"
              color="text.primary"
              sx={{ mb: 10 }}
            >
              <ArrowBackRoundedIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("common:back")}
            </Link>
            <Stack>
              <Typography variant="h1" width="90%">
                <Skeleton />
              </Typography>
              <Skeleton height={40} width={235} />
              <Typography variant="body1">
                <Skeleton />
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </TitleHeroStyled.Hero>
  );
};

export default TitleHeroSkeleton;
